import { render, staticRenderFns } from "./transferClerk.vue?vue&type=template&id=1c962ed2"
import script from "./transferClerk.vue?vue&type=script&lang=js"
export * from "./transferClerk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports